// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lurantis: PokeData = {
  "id": 754,
  "name": "lurantis",
  "height": 9,
  "weight": 185,
  "base_experience": 168,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "growth",
    "razor-leaf",
    "solar-beam",
    "slash",
    "fury-cutter",
    "sweet-scent",
    "synthesis",
    "sunny-day",
    "ingrain",
    "leaf-blade",
    "night-slash",
    "x-scissor",
    "dual-chop",
    "petal-blizzard",
    "solar-blade",
    "leafage"
  ],
  "moves": [
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "sunny-day",
    "night-slash",
    "branch-poke",
    "flower-rush",
    "frenzy-plant",
    "bullet-seed",
    "vine-whip",
    "overgrowth",
    "leaf-tornado",
    "aromatherapy"
  ],
  "evolution_chain": {
    "id": 388,
    "item": null,
    "species": [
      {
        "name": "fomantis",
        "order": 753,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lurantis",
        "order": 754,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 753,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 139,
    "speed": 78,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
